export const PaymentOptionTypes = {
  quick: 'quick',
  bespoke: 'bespoke'
};
